import { Eye } from 'lucide-react';
import React, { useEffect, useState } from "react";
import apiService from "../services/apiService";

const LogTable = () => {
  const [logs, setLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 20;

  useEffect(() => {
    fetchLog();
  }, [offset]);

  const fetchLog = async () => {
    try {
      const response = await apiService.postData("admin/logs", {
        limit,
        offset,
      });

      if (!response.error && response.data) {
        setLogs(response.data.rows);
        setTotalCount(response.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  const handleView = (log) => {
    setSelectedLog(log);
  };

  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  const renderPagination = () => {
    const pageButtons = [];
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) {
        pageButtons.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - halfRange);
      let endPage = Math.min(totalPages, currentPage + halfRange);

      if (startPage > 1) pageButtons.push(1);
      if (startPage > 2) pageButtons.push("...");

      for (let i = startPage; i <= endPage; i++) {
        pageButtons.push(i);
      }

      if (endPage < totalPages - 1) pageButtons.push("...");
      if (endPage < totalPages) pageButtons.push(totalPages);
    }

    return pageButtons.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setOffset((page - 1) * limit)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="btn mx-1 disabled">
          {page}
        </span>
      )
    );
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4>Log Table</h4>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Device ID</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, index) => (
                  <tr key={index}>
                    <td>{index + 1 + offset}</td>
                    <td>{log.uid}</td>
                    {/* <td>{JSON.parse(log.log).uid}</td> */}
                    <td>{log.log_date ? new Date(log.log_date).toLocaleDateString("en-GB").replace(/\//g, "-") : "-"}</td>
                    <td>{log.log_time}</td>
                    <td>
                      <button className="btn btn-primary btn-sm text-white" onClick={() => handleView(log)}>
                        <Eye size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <nav className="d-flex justify-content-center my-3">
        <button
          className="btn btn-outline-primary me-2"
          onClick={() => setOffset(offset - limit)}
          disabled={offset === 0}
        >
          «
        </button>
        {renderPagination()}
        <button
          className="btn btn-outline-primary ms-2"
          onClick={() => setOffset(offset + limit)}
          disabled={offset + limit >= totalCount}
        >
          »
        </button>
      </nav>

          {selectedLog && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Log Details</h5>
                    <button className="btn-close" onClick={() => setSelectedLog(null)}></button>
                  </div>
                  <div className="modal-body">
                  {/* <pre>{JSON.stringify(JSON.parse(selectedLog.log)[0], null, 2)}</pre> */}
                  <pre>{JSON.stringify(JSON.parse(selectedLog.log), null, 2)}</pre>

                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setSelectedLog(null)}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogTable;
